import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=2d9cf246&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"
import style0 from "../assets/css/shop.css?vue&type=style&index=0&id=2d9cf246&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9cf246",
  null
  
)

export default component.exports